import { IonModal } from '@ionic/react';
import { Button } from '../components/button/Button';
import { PageContent } from '../components/page/PageContent';
import { PageHeader } from '../components/page/PageHeader';
import { PageFooter } from '../components/page/PageFooter';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { ProState } from './ProState';
import { PreMissionWeatherFeatureAnnouncement } from './PreMissionWeatherFeatureAnnouncement';
import { useSubscription } from '@meraki-internal/state';

export const AnnouncementModal: React.FC = () => {
    const modalState = useInstance(PreMissionWeatherFeatureAnnouncement);
    useSubscription(() => modalState);

    const proState = useInstance(ProState);

    const onContinue = () => {
        modalState.close();
        proState.showPaywall('weather announcement');
    };

    return (
        <IonModal isOpen={modalState.isOpen} onDidDismiss={() => modalState.close()}>

            <PageHeader transparent onClose={modalState.close} />

            <PageContent noScroll>
                <div style={{padding: 20, maxWidth: 400, width: '100%', margin: 'auto'}}>
                    <img src={modalState.getImagePath()} alt="Weather Announcement" />
                </div>
            </PageContent>

            <PageFooter>
                <hr style={{ backgroundColor: '#eee' }} />
                <div style={{margin: '50px 30px'}}>
                    <Button expand="block" onClick={onContinue}>Continue</Button>
                </div>
            </PageFooter>

        </IonModal>
    );
};
